import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d61476c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nowrap-cell gray" }
const _hoisted_2 = { class: "nowrap-cell" }
const _hoisted_3 = { class: "nowrap-cell" }
const _hoisted_4 = { class: "nowrap-cell" }

import { computed, onMounted, onBeforeUnmount, ref } from "vue";
import { useI18n } from "vue-i18n";

type Props = {
  table: Array<any>;
  tablePercentageRanges?: Array<any>;
  parameter?: Record<string, any>;
  getTmoaNameByValue?: (a?: any, b?: any, c?: any) => string;
  isTmoaData?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  props: {
    table: null,
    tablePercentageRanges: null,
    parameter: null,
    getTmoaNameByValue: null,
    isTmoaData: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  table: Array<any>;
  tablePercentageRanges?: Array<any>;
  parameter?: Record<string, any>;
  getTmoaNameByValue?: (a?: any, b?: any, c?: any) => string;
  isTmoaData?: boolean;
}

const { t } = useI18n();



const isWideScreen = ref<boolean>(window.innerWidth > 1490);

const updateScreenSize = () => {
  isWideScreen.value = window.innerWidth > 1445;
};

onMounted(() => {
  window.addEventListener("resize", updateScreenSize);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateScreenSize);
});

const formatCell = (_: any, __: any, value: any) =>
  value === undefined || value === "N/A" ? "-" : value;

const getHeaderLabel = (index: number) => {
  const row = props.table?.[index];
  if (!row) return "";

  if (props.isTmoaData) {
    return props.getTmoaNameByValue?.(null, null, row.nameRange) ?? row.nameRange;
  }

  return `Rango ${row.nameRange}`;
};

const transposedTable = computed(() => {
  if (!props.table?.length) return [];

  return [
    {
      metric: t("label.min"),
      ...props.table.reduce((acc, r, i) => ({ ...acc, [`col_${i}`]: r.min_duration }), {}),
    },
    {
      metric: t("label.max"),
      ...props.table.reduce((acc, r, i) => ({ ...acc, [`col_${i}`]: r.max_duration }), {}),
    },
    {
      metric: t("label.average"),
      ...props.table.reduce((acc, r, i) => ({ ...acc, [`col_${i}`]: r.average_duration }), {}),
    },
    {
      metric: t("label.median"),
      ...props.table.reduce((acc, r, i) => ({ ...acc, [`col_${i}`]: r.median }), {}),
    },
    {
      metric: t("label.total"),
      ...props.table.reduce((acc, r, i) => ({ ...acc, [`col_${i}`]: r.total }), {}),
    },
  ];
});

const columnKeys = computed(() => {
  const keys = props.table?.map((_: any, index: number) => `col_${index}`) ?? [];
  // return keys;
  return props.isTmoaData ? keys.slice(0, -1) : keys;
});

const columnKeys2 = computed(() => {
  const keys = props.table?.map((_: any, index: number) => `col_${index}`) ?? [];
  // return keys;
  return props.isTmoaData ? keys.slice(0, -1) : keys;
});

const TIME_RANGES = ["Total", "≤ 5min", "≤ 10min", "≤ 15min", "≤ 30min", "≤ 1h", "> 1h"];

const dataByTime = computed(() => {
  const percentages = props.tablePercentageRanges ?? [];

  if (!percentages.length) return [];

  return TIME_RANGES.map((range) => {
    const row: Record<string, any> = { metric: range };

    percentages.forEach((typology, i) => {
      const colName = `col_${i}`;
      const perc = typology?.percentages ?? {};

      switch (range) {
        case "Total":
          row[colName] = perc.total ?? 0;
          break;
        case "≤ 5min":
          row[colName] = `${perc.min5 ?? 0} %`;
          break;
        case "≤ 10min":
          row[colName] = `${perc.min10 ?? 0} %`;
          break;
        case "≤ 15min":
          row[colName] = `${perc.min15 ?? 0} %`;
          break;
        case "≤ 30min":
          row[colName] = `${perc.min30 ?? 0} %`;
          break;
        case "≤ 1h":
          row[colName] = `${perc.h1 ?? 0} %`;
          break;
        case "> 1h":
          row[colName] = `${perc.other ?? 0} %`;
          break;
      }
    });

    return row;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, {
      id: "header-metrics",
      class: "header gray"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("label.durationAnalysis")), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_el_table, {
      data: _unref(transposedTable),
      border: "",
      fit: "",
      style: {"width":"100%","table-layout":"fixed"},
      class: "tables"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "metric",
          class: "gray",
          label: "Métrica",
          "min-width": "65"
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columnKeys), (col, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            key: col,
            prop: col,
            label: getHeaderLabel(index),
            "min-width": "80",
            align: "center"
          }, {
            header: _withCtx(({ column }) => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(column.label), 1)
            ]),
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_2, _toDisplayString(formatCell(null, null, row[col])), 1)
            ]),
            _: 2
          }, 1032, ["prop", "label"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_row, {
      class: "header",
      style: {"margin-top":"24px"}
    }),
    _createVNode(_component_el_table, {
      data: _unref(dataByTime),
      border: "",
      style: {"margin-top":"8px","width":"100%"},
      class: "tables"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "metric",
          label: "Duración",
          "class-name": "min-col",
          "min-width": "65"
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columnKeys2), (col, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            align: "center",
            key: col,
            prop: col,
            label: getHeaderLabel(index),
            "min-width": "80"
          }, {
            header: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(scope.column.label), 1)
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(formatCell(null, null, scope.row[col])), 1)
            ]),
            _: 2
          }, 1032, ["prop", "label"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["data"])
  ], 64))
}
}

})